var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"ba b--light-gray flex items-center",attrs:{"to":_vm.link}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }